import React, {useState} from "react";
import {Button, FormGroup, Input, Label, ListGroup, ListGroupItem} from "reactstrap";
import FormModal from "../../../shared/components/FormModal";
import {DiscountSummary} from "./OrderSummaries";
import RowActions from "../../../shared/components/RowActions";
import IconLabel from "../../../shared/components/IconLabel";
import {PlusIcon} from "../../../shared/components/icons";

/**
 * @typedef {{type: "VAL"|"PER", value: string, description: string}} Discount
 * @param {{
 *   discount: Discount|null,
 *   amount: number,
 *   currency?: string,
 *   errors: Record<string, string>,
 *   onChange: (discount: Discount|null) => void,
 * }} props
 */
const OrderDiscountEditor = ({discount, amount, currency, errors, onChange}) => {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);

    return (
        <>
            {!discount && <p className="text-muted">Nenhum desconto aplicado.</p>}
            {discount && (
                <ListGroup className="mb-3">
                    <ListGroupItem className="d-flex align-items-start gap-2">
                        <DiscountSummary
                            type={discount.type}
                            value={Number(discount.value)}
                            description={discount.description}
                            amount={amount}
                            currency={currency}
                            errors={Object.values(errors)}
                        />
                        <RowActions noun="desconto" onEdit={() => setOpen(true)} onRemove={() => onChange(null)} />
                    </ListGroupItem>
                </ListGroup>
            )}
            {!discount && (
                <Button color="primary" outline size="sm" onClick={() => setOpen(true)}>
                    <IconLabel icon={<PlusIcon />}>Adicionar desconto</IconLabel>
                </Button>
            )}

            <FormModal
                isOpen={open}
                toggle={close}
                title={discount ? "Editar desconto" : "Adicionar desconto"}
                initial={/** @type {Discount} */ (discount ?? {type: "VAL", value: "", description: ""})}
                canSave={(v) => Number(v.value) > 0 && (v.type !== "PER" || Number(v.value) <= 100)}
                onSave={(v) => {
                    onChange({...v, description: v.description.trim()});
                    close();
                }}
            >
                {(values, set) => (
                    <>
                        <FormGroup>
                            <Label for="discount-type">Tipo</Label>
                            <Input
                                id="discount-type"
                                type="select"
                                value={values.type}
                                onChange={(e) => set({type: /** @type {"VAL"|"PER"} */ (e.target.value)})}
                            >
                                <option value="VAL">Valor</option>
                                <option value="PER">Percentual</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="discount-value">{values.type === "PER" ? "Percentual (%)" : "Valor"}</Label>
                            <Input
                                id="discount-value"
                                type="number"
                                min="0"
                                max={values.type === "PER" ? "100" : undefined}
                                step="1"
                                autoFocus
                                value={values.value}
                                onChange={(e) => set({value: e.target.value})}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="discount-description">Motivo</Label>
                            <Input
                                id="discount-description"
                                placeholder="opcional"
                                value={values.description}
                                onChange={(e) => set({description: e.target.value})}
                            />
                        </FormGroup>
                    </>
                )}
            </FormModal>
        </>
    );
};

export default OrderDiscountEditor;
